
const videoStyle = {
  'modal-video-close-btn': {
    "&:hover,&:focus": {
      cursor: "pointer",
      opacity: 0.8
    }
  },
  playVideo: {
    color: 'white',
    "&:hover,&:focus": {
      opacity: 0.8
    }
  }
};

export default videoStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/next-genius/views/landingPageSections/videoStyle.jsx